// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#floating__nav {
  display: none;
  animation: animateFloatingNav 300ms ease forwards;
}

@keyframes animateFloatingNav {
  from {
    opacity: 0;

    bottom: -5rem;
  }

  to {
    opacity: 1;

    bottom: 3rem;
  }
}

/* Media queries tablets and phones */
@media (max-width: 1024px) {
  #floating__nav {
    display: flex;
    position: fixed;
    align-items: center;
    bottom: 3rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
  }

  #floating__nav ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 60px;
  }

  .scrollspy {
    display: flex;
    gap: 1rem;
    background: rgba(0, 0, 0, 0.4);
    padding: 0.8rem 1.5rem;
    border-radius: 3rem;
    backdrop-filter: blur(20px);
  }

  #floating__nav a {
    padding: 0.6rem;
    border-radius: 50%;
    font-size: 1.3rem;
    color: white;
    display: grid;
  }

  #floating__nav li.active a {
    background: var(--color-primary);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/floating-nav/floatingNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;;IAEV,aAAa;EACf;;EAEA;IACE,UAAU;;IAEV,YAAY;EACd;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":["#floating__nav {\n  display: none;\n  animation: animateFloatingNav 300ms ease forwards;\n}\n\n@keyframes animateFloatingNav {\n  from {\n    opacity: 0;\n\n    bottom: -5rem;\n  }\n\n  to {\n    opacity: 1;\n\n    bottom: 3rem;\n  }\n}\n\n/* Media queries tablets and phones */\n@media (max-width: 1024px) {\n  #floating__nav {\n    display: flex;\n    position: fixed;\n    align-items: center;\n    bottom: 3rem;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 9;\n  }\n\n  #floating__nav ul {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 20px;\n    height: 60px;\n  }\n\n  .scrollspy {\n    display: flex;\n    gap: 1rem;\n    background: rgba(0, 0, 0, 0.4);\n    padding: 0.8rem 1.5rem;\n    border-radius: 3rem;\n    backdrop-filter: blur(20px);\n  }\n\n  #floating__nav a {\n    padding: 0.6rem;\n    border-radius: 50%;\n    font-size: 1.3rem;\n    color: white;\n    display: grid;\n  }\n\n  #floating__nav li.active a {\n    background: var(--color-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
